var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title"},[_vm._v("中交智运⽤户服务协议")]),_c('User')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }